import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import { GraphData, GraphDataParams } from './types/graphTypes'

const fetchGraphData = async (params: GraphDataParams): Promise<GraphData> => {
  const queryParams = new URLSearchParams()
  if (params.mode) queryParams.append('mode', params.mode)
  if (params.edgeTypes) queryParams.append('edgeTypes', params.edgeTypes)
  if (params.lang) queryParams.append('lang', params.lang)
  const { data } = await api.get<GraphData>(`/ft_graph-data?${queryParams}`)
  return data
}

export const useGetGraphData = (params: GraphDataParams = {}) => {
  return useQuery<GraphData>({
    queryKey: ['ft-graph-data', params],
    queryFn: () => fetchGraphData(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
